import React from 'react';
import { Heart } from 'lucide-react';

export function AboutStory() {
  return (
    <div className="space-y-8">
      {/* Our Story */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <Heart className="w-6 h-6 text-accessible-red-600" />
          </div>
          <h2 className="card-title">
            Historia Fundacji Znajdki
          </h2>
        </div>
        
        <div className="space-y-4">
          <p className="body-medium">
            Nasza Fundacja powstała z miłości do zwierząt i potrzeby pomocy tym, którzy nie mieli nikogo. 
            Porzuconym, niepotrzebnym, niechcianym, bo starym, chorym, bezdomnym... Znajdkom.
          </p>
          <p className="body-medium">
            Los znajdków wzięła w swoje ręce nasza prezes, Jola Boczkowska, i w 2012 roku założyła 
            Fundację, by ratować je przed bezdomnością. Niestety, w 2019 roku pani Jola odeszła 
            z powodu choroby onkologicznej. Fundacja działa dalej z nowym zarządem.
          </p>
          <p className="body-medium">
            Każdego roku ratujemy ponad 350 psów i kotów.
          </p>
          <p className="body-medium">
            Leczymy, sterylizujemy, socjalizujemy i szukamy domów, w których będą kochane i rozpieszczane.
          </p>
        </div>
      </div>

      {/* Our Mission */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <Heart className="w-6 h-6 text-accessible-red-600" />
          </div>
          <h2 className="card-title">
            Nasza misja
          </h2>
        </div>
        
        <div className="space-y-4">
          <p className="body-medium">
            Działalność Fundacji jest możliwa dzięki wolontariuszom i darczyńcom, którzy widząc, 
            jak zmieniają się zwierzęta pod naszą opieką, wspierają nas finansowo w niesieniu im pomocy.
          </p>
          <p className="body-medium">
            Nasi wolontariusze prowadzący domy tymczasowe przekonują psy i koty, że człowiek to ktoś, 
            komu można zaufać, kto zadba o jedzenie, przytuli i nauczy, jak żyć.
          </p>
          <p className="body-medium">
            Codzienna opieka nad naszymi podopiecznymi to ogromny wysiłek zaledwie kilku osób związanych 
            z Fundacją, dlatego każda pomoc, każde wsparcie w naszej działalności przyjmowane jest z wdzięcznością.
          </p>
          <p className="body-medium">
            Zachęcamy - pomóż nam pomagać Znajdkom!
          </p>
        </div>
      </div>
    </div>
  );
}